module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "qa8sxunw",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
  auth: false,
};
